export default __webpack_public_path__ + "static/media/Johndoe.b71abade.jpg";